var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#716E6E",
    strokeLinecap: "round",
    d: "M5.5 1.5C2.73858 1.5 0.5 3.73858 0.5 6.5C0.5 9.26142 2.73858 11.5 5.5 11.5C8.26142 11.5 10.5 9.26142 10.5 6.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#716E6E",
    fillRule: "evenodd",
    d: "M3.875 5.75C4.35825 5.75 4.75 5.35825 4.75 4.875C4.75 4.39175 4.35825 4 3.875 4C3.39175 4 3 4.39175 3 4.875C3 5.35825 3.39175 5.75 3.875 5.75ZM7.125 5.75C7.60825 5.75 8 5.35825 8 4.875C8 4.39175 7.60825 4 7.125 4C6.64175 4 6.25 4.39175 6.25 4.875C6.25 5.35825 6.64175 5.75 7.125 5.75ZM5.5 9.5C4.11929 9.5 3 8.38071 3 7H8C8 8.38071 6.88071 9.5 5.5 9.5Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#716E6E",
    strokeLinecap: "round",
    d: "M9.64554 0.84082V4.34082"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#716E6E",
    strokeLinecap: "round",
    d: "M11.3955 2.62012L7.89554 2.62012"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReaction);
export default __webpack_public_path__ + "static/media/reaction.760baeb8bdd6d4f2c52b34e2fde63eab.svg";
export { ForwardRef as ReactComponent };